import {
  CellClickedEvent,
  ColDef,
  GridOptions,
  ICellRendererParams,
  ValueGetterParams,
} from '@ag-grid-community/core';

import { AgIconLinkCellComponent } from '@shared/ag-components/ag-icon-link-cell/ag-icon-link-cell.component';
import { AgTooltipComponent } from '@shared/components/ag-tooltip/ag-tooltip.component';
import { MessagesConstants } from '@shared/constants/messages.constants';
import { TableConstants } from '@shared/constants/table.constants';
import { Utils } from '@shared/utils/utils';

import { NoPrepaidsOverlayComponent } from './no-prepaids-overlay/no-prepaids-overlay.component';

export const PrepaidsGridOptions = (
  onVendorClick: (event: CellClickedEvent) => void
): GridOptions => ({
  ...TableConstants.DEFAULT_GRID_OPTIONS.GRID_OPTIONS,
  columnDefs: [
    {
      cellClass: (value) => {
        const classes: string[] = ['text-left', 'cursor-pointer'];

        if (!value.node.rowPinned) {
          if (value.data.vendor_id !== null) {
            classes.push('aux-link');
          } else {
            classes.push('aux-link-zero-hyphen');
          }
        }

        return classes;
      },
      cellDataType: 'text',
      cellRenderer: AgIconLinkCellComponent,
      cellRendererParams: (params: ICellRendererParams) => {
        return {
          icons: [
            {
              icon: 'AlertTriangle',
              iconClass: 'text-aux-red-dark',
              iconTooltipMessages: [MessagesConstants.PREPAIDS.PREPAID_NEED_YOUR_ATTENTION],
              showIcon: params.data.has_incomplete_details,
            },
          ],
          rowReverse: true,
        };
      },
      field: 'vendor_id',
      headerName: 'Vendor Contract',
      minWidth: 140,
      onCellClicked: (event: CellClickedEvent) => onVendorClick(event),
      valueFormatter: Utils.dashFormatter,
      valueGetter: (params: ValueGetterParams) => {
        if (params.node?.rowPinned === 'bottom') {
          return params.data.vendor_id;
        }

        return params.data?.vendor_name || '';
      },
    },
    {
      cellClass: TableConstants.STYLE_CLASSES.CELL_ALIGN_RIGHT,
      cellDataType: 'number',
      field: 'total_prepaid_balance',
      headerName: 'Total Prepaid Balance',
      minWidth: 200,
      valueFormatter: (params) => {
        return Utils.agCurrencyFormatter(params, params.data.vendor_currency);
      },
    },
    ...termsColumns,
  ],
  defaultColDef: {
    ...TableConstants.DEFAULT_GRID_OPTIONS.DEFAULT_COL_DEF,
    resizable: true,
  },
  noRowsOverlayComponent: NoPrepaidsOverlayComponent,
});

const termsColumns: ColDef[] = [
  {
    cellClass: TableConstants.STYLE_CLASSES.CELL_ALIGN_RIGHT,
    cellDataType: 'number',
    field: 'short_term_amount',
    headerName: 'Short Term',
    minWidth: 140,
    valueFormatter: (params) => {
      return Utils.agCurrencyFormatter(params, params.data.vendor_currency);
    },
  },
  {
    cellClass: TableConstants.STYLE_CLASSES.CELL_ALIGN_RIGHT,
    cellDataType: 'number',
    field: 'long_term_amount',
    headerName: 'Long Term',
    minWidth: 140,
    valueFormatter: (params) => {
      return Utils.agCurrencyFormatter(params, params.data.vendor_currency);
    },
  },
  {
    cellClass: ['!block', TableConstants.STYLE_CLASSES.CELL_ALIGN_LEFT],
    cellRenderer: AgTooltipComponent,
    field: 'terms',
    headerName: 'Terms',
    minWidth: 200,
  },
];
